import React from "react";
import { Link } from "react-router-dom";

export default function SiteFooter({ showTagline = true }) {
  return (
    <footer
      className="site-footer"
      data-testid="site-footer"
      style={{
        marginTop: 48,
        paddingTop: 32,
        borderTop: "1px solid var(--hairline)",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        gap: 12,
      }}
    >
      {showTagline && (
        <div
          className="serif-italic"
          style={{ fontSize: 18, fontWeight: 500, color: "#1a1008", letterSpacing: 0 }}
        >
          Let Go. Live Free. Love Fully.
        </div>
      )}
      <div
        style={{
          display: "flex",
          gap: 24,
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
          fontFamily: "Montserrat, sans-serif",
          fontSize: 10,
          letterSpacing: "0.25em",
          textTransform: "uppercase",
          color: "var(--muted)",
        }}
      >
        <Link
          to="/privacy"
          data-testid="footer-privacy-link"
          style={{ color: "inherit", borderBottom: "1px solid transparent", transition: "color 0.3s ease, border-color 0.3s ease" }}
          onMouseEnter={(e) => { e.currentTarget.style.color = "var(--ink)"; e.currentTarget.style.borderBottomColor = "var(--ink)"; }}
          onMouseLeave={(e) => { e.currentTarget.style.color = "var(--muted)"; e.currentTarget.style.borderBottomColor = "transparent"; }}
        >
          Privacy
        </Link>
        <span style={{ opacity: 0.4 }}>·</span>
        <span>© {new Date().getFullYear()} 111 Collective</span>
      </div>
    </footer>
  );
}
